import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Layout from 'components/Layout'
import Loader from 'components/Loader'
import CustomTendersComponent from 'components/CustomTenders'
import ListFilters from 'components/CustomTenders/ListFilters'

import { getCurrentVenueUuid } from 'store/Venues/selector'
import { fetchCustomPaymentTypes } from 'store/CustomPaymentTypes/actions'
import { getIsCustomPaymentTypesLoading } from 'store/CustomPaymentTypes/selectors'

const SalesEvents = () => {
  const dispatch = useDispatch()
  const venueUuid = useSelector(getCurrentVenueUuid)
  const isLoading = useSelector(getIsCustomPaymentTypesLoading)

  useEffect(() => {
    dispatch(fetchCustomPaymentTypes(venueUuid))
  }, [venueUuid, dispatch])

  return (
    <Layout
      isSidebar
      navbarContent={<ListFilters />}
      mainContent={
        isLoading ? <Loader /> : <CustomTendersComponent />
      }
    />
  )
}

export default SalesEvents
